import dayjs, { Dayjs } from "dayjs";
// https://gist.github.com/AllanPooley/c41f2e4a0e63e3eaf89b57f2570fcb55
export function getGreetingTime() {
    const currentTime = dayjs();
    const splitAfternoon = 12; // 24hr time to split the afternoon
    const splitEvening = 17; // 24hr time to split the evening
    const currentHour = parseFloat(currentTime.format('HH'));
    if (currentHour >= splitAfternoon && currentHour <= splitEvening) {
        // Between 12 PM and 5PM
        return 'Good afternoon';
    }
    else if (currentHour >= splitEvening) {
        // Between 5PM and Midnight
        return 'Good evening';
    }
    // Between dawn and noon
    return 'Good morning';
}
export function secondsOfDay(m) {
    return (m.hour() * 3600) + (m.minute() * 60) + m.second();
}
export function todayAtMidnight() {
    return dayjs().startOf('day');
}
export function formatTimeWithoutSeconds(strTime) {
    if (!strTime) {
        return '';
    }
    const parts = strTime.split(':');
    return `${parts[0]}:${parts[1]}`;
}
export function formatTimeAsPreciseDuration(time) {
    const seconds = secondsOfDay(dayjs(time, 'HH:mm:ss'));
    return stringifyDuration(dayjs.duration(seconds, "seconds"));
}
/**
 * from: https://github.com/moment/moment/issues/348#issuecomment-428713411
 */
export function stringifyDuration(duration) {
    const durationComponents = [
        { value: duration.years(), unit: 'year' },
        { value: duration.months(), unit: 'month' },
        { value: duration.days(), unit: 'day' },
        { value: duration.hours(), unit: 'hour' },
        { value: duration.minutes(), unit: 'minute' },
        { value: duration.seconds(), unit: 'second' },
        { value: duration.milliseconds(), unit: 'millisecond' }
    ];
    return durationComponents
        .filter(({ value }) => value !== 0)
        .slice(0, 3)
        .map(({ unit, value }) => {
        return "" + value + " " + (value > 1 ? unit + "s" : unit);
    })
        .join(', ');
}
export function timeAsMinutes(time) {
    const m = dayjs(time, 'HH:mm:ss');
    return (m.hour() * 60) + m.minute();
}
export function formatSecondsAsDuration(seconds) {
    if (!seconds) {
        return '';
    }
    if (seconds < 60) {
        return "00:01";
    }
    return formatMinutesAsTime(Math.round(seconds / 60));
}
export function formatTimeRange(fromTime, toTime) {
    if (fromTime && toTime) {
        return formatTimeAsAMPM(fromTime) + "-" + formatTimeAsAMPM(toTime);
    }
    else if (fromTime) {
        return "After " + formatTimeAsAMPM(fromTime);
    }
    else if (toTime) {
        return "Before " + formatTimeAsAMPM(toTime);
    }
    return '';
}
export function formatTimeAsAMPM(strTime) {
    if (strTime) {
        const m = dayjs(strTime, 'HH:mm:ss');
        if (m.minute() === 0) {
            return m.format("ha");
        }
        return m.format("h:mma");
    }
    return strTime;
}
export function formatMinutesAsTime(minutes) {
    if (minutes == undefined) {
        return '';
    }
    const h = Math.floor(minutes / 60);
    const m = Math.floor(minutes % 60);
    return [
        h > 9 ? h : '0' + h,
        m > 9 ? m : '0' + m
    ].join(':');
}
export function lessThanOneHourFromNow(date) {
    return dayjs(date).subtract(1, 'hours').isBefore(dayjs());
}
export function isBeforeNow(date) {
    return dayjs(date).isBefore(dayjs());
}
